export const jobPosts = {
  alerts: {
    errorApplied: 'Er ging iets mis bij het versturen van je reactie. Probeer je het later nog eens?',
    successCancelled: 'Je opdracht is geannuleerd en wordt niet meer getoond.',
    successCreated: 'Je opdracht is aangemaakt.',
    successFilled: 'Je opdracht is ingevuld en wordt niet meer getoond.',
    successUpdated: 'Je opdracht is bewerkt.',
  },
  apply: {
    actions: {
      submit: 'Versturen',
    },
    motivation: {
      explanation: 'Schrijf hier een persoonlijke reactie neer voor je klant.',
      title: 'Je motivatie',
    },
    profile: {
      contactDetails: 'Je contactgegevens',
      explanation: 'Onderstaande gegevens delen we met je klant. Je kan zelf uitvinken welke info je liever niet deelt.',
      fields: {
        address: 'Adres',
        email: 'E-mailadres',
        links: 'Links',
        phone: 'Telefoonnummer',
      },
      introductionText: 'Introductie',
      title: 'Je profiel',
    },
    successDialog: {
      buttonText: 'Got it!',
      description:
        'Je reactie is verstuurd naar de klant. Hij/zij/die ontvangt hiervan een e-mail en neemt daarna (hopelijk) contact op met jou. Even wachten dus.',
      title: 'Reactie verstuurd',
    },
    title: 'Contacteer',
  },
  breadcrumb: {
    bookmarked: 'Bewaarde opdrachten',
    create: 'Opdracht aanmaken',
    overview: 'Opdrachten',
    own: 'Mijn opdrachten',
  },
  card: {
    postedByCS: 'Gecureerd door Creative Shelter',
    postedByFreelancer: 'Gepost door een freelancer',
  },
  contextMenu: {
    actions: {
      cancelled: 'Annuleren',
      edit: 'Bewerken',
      filled: 'Ingevuld',
    },
    dialogs: {
      cancelled: {
        actions: {
          cancel: 'Nee, ga terug',
          confirm: 'Ja, ik ben zeker!',
        },
        description: 'Je opdracht krijgt als status ‘geannuleerd’ en wordt niet meer getoond. Deze aanpassing kan je niet ongedaan maken.',
        title: 'Ben je zeker?',
      },
      filled: {
        actions: {
          cancel: 'Nee, ga terug',
          confirm: 'Ja, ik ben zeker!',
        },
        description: 'Je opdracht krijgt als status ‘ingevuld’ en wordt niet meer getoond. Deze aanpassing kan je niet ongedaan maken.',
        title: 'Ben je zeker?',
      },
    },
  },
  createEdit: {
    actions: {
      create: 'Opdracht aanmaken',
    },
    blocker: 'Ben je zeker dat je de pagina wilt verlaten? Je opdracht is niet opgeslagen.',
    sections: {
      basic: {
        title: 'Basisinformatie',
      },
      details: {
        title: 'Opdrachtdetails',
      },
      planning: {
        title: 'Planning',
      },
    },
    title: {
      create: 'Nieuwe opdracht',
      edit: 'Bewerk opdracht',
    },
  },
  details: {
    actions: {
      alreadyApplied: 'Al gecontacteerd',
      apply: 'Contacteer klant',
    },
    info: {
      alreadyApplied: {
        description: 'Je nam contact op met je klant, nu is het even wachten op reactie.',
        title: 'Klant gecontacteerd',
      },
      userHasCreated: {
        description: 'Je kan er zelf niet op reageren, maar je kan ze wel aanpassen als je dat wilt.',
        title: 'Deze opdracht heb je zelf geplaatst',
      },
    },
  },
  fields: {
    activities: {
      label: 'Soort opdracht',
      placeholder: 'Selecteer',
    },
    closesAt: {
      label: 'Reageren voor',
    },
    createdAt: {
      label: 'Aangemaakt op',
    },
    description: {
      label: 'Beschrijving',
    },
    endsAt: {
      label: 'Einddatum',
    },
    experienceLevel: {
      label: 'Ervaring',
      options: {
        Junior: 'Junior',
        Medior: 'Medior',
        Senior: 'Senior',
      },
      placeholder: 'Selecteer',
    },
    isPriceToBeDiscussed: {
      label: 'Te bespreken',
    },
    locationType: {
      label: 'Werkplek',
      options: {
        Hybrid: 'Hybride',
        Onsite: 'Op locatie',
        Remote: 'Remote',
      },
      placeholder: 'Selecteer',
    },
    price: {
      label: 'Budget',
      placeholder: 'Budget',
    },
    priceUnit: {
      label: 'Eenheid',
      options: {
        Daily: 'Dag',
        Fixed: 'Vaste fee',
        HalfDaily: 'Halve dag',
        Hourly: 'Uur',
        PricePerWord: 'Woord',
      },
      placeholder: 'Eenheid per prijs',
    },
    region: {
      label: 'Locatie opdracht',
      placeholder: 'Selecteer',
    },
    startsAt: {
      label: 'Startdatum',
    },
    status: {
      options: {
        Cancelled: 'Geannuleerd',
        Filled: 'Ingevuld',
        Open: 'Open',
      },
    },
    title: {
      label: 'Titel',
      placeholder: 'Titel',
    },
  },
  overview: {
    actions: {
      create: 'Opdracht aanmaken',
    },
    bookmarked: {
      empty: 'Je hebt nog geen opdrachten bewaard.',
    },
    description: 'Vind hier kwalitatieve opdrachten terug van andere freelancers en externe klanten.',
    error: {
      title: 'Fout bij het laden van de opdrachten.',
    },
    filters: {
      activities: 'Activiteiten',
      locationType: 'Werkplek',
      regions: 'Regio’s',
    },
    loading: 'Gegevens aan het laden…',
    own: {
      empty: 'Je hebt nog geen opdrachten aangemaakt.',
    },
    resetFilters: '(filters wissen)',
    resultCount_one: '{{count}} resultaat',
    resultCount_other: '{{count}} resultaten',
    resultCount_zero: 'Geen match gevonden op basis van je filters',
    title: 'Opdrachten',
  },
  specifications: {
    closesAt: 'Reageren voor',
    experienceLevel: 'Ervaring',
    location: 'Locatie',
    locationType: 'Werkplek',
    period: 'Periode',
    price: 'Budget',
  },
  tabs: {
    all: 'Alle opdrachten',
    bookmarked: 'Bewaarde opdrachten',
    own: 'Eigen opdrachten',
  },
};
